import { render, staticRenderFns } from "./FilterSlicer.vue?vue&type=template&id=9dede62e&scoped=true"
import script from "./FilterSlicer.vue?vue&type=script&lang=js"
export * from "./FilterSlicer.vue?vue&type=script&lang=js"
import style0 from "./FilterSlicer.vue?vue&type=style&index=0&id=9dede62e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dede62e",
  null
  
)

export default component.exports